import { Vector3 } from "@babylonjs/core/Maths/math.vector";
import { projectPointOnLine3 } from "../utils/MathUtils";
var SnapLine = /** @class */ (function () {
    function SnapLine(pPoint1, pPoint2, pIsSegment) {
        if (pIsSegment === void 0) { pIsSegment = false; }
        this.mPoint1 = pPoint1;
        this.mPoint2 = pPoint2;
        this.locked = false;
        this.isSegment = pIsSegment;
        this.updateDirection();
    }
    Object.defineProperty(SnapLine.prototype, "point1", {
        get: function () {
            return (this.mPoint1);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SnapLine.prototype, "point2", {
        get: function () {
            return (this.mPoint2);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SnapLine.prototype, "direction", {
        get: function () {
            return (this.mDirection);
        },
        enumerable: false,
        configurable: true
    });
    SnapLine.prototype.setPoint1 = function (pPoint) {
        this.mPoint1 = pPoint;
        this.updateDirection();
    };
    SnapLine.prototype.setPoint2 = function (pPoint) {
        this.mPoint2 = pPoint;
        this.updateDirection();
    };
    SnapLine.FromAxis = function (pOrigin, pAxis) {
        return (new SnapLine(pOrigin, pOrigin.add(pAxis)));
    };
    /**
     * Find nearest snap line. If pView is null pSnapDistance will be handled as meter otherwise as pixel.
     */
    SnapLine.Snap = function (pPos, pLines, pView, pSnapDistance) {
        if (pSnapDistance === void 0) { pSnapDistance = 15; }
        if (pPos == null || pLines == null)
            return (null);
        var tNearestLine = null;
        var tDistance = 0;
        var tNewPos = null;
        for (var _i = 0, pLines_1 = pLines; _i < pLines_1.length; _i++) {
            var tLine = pLines_1[_i];
            var tProjPos = projectPointOnLine3(pPos, tLine.mPoint1, tLine.mPoint2, tLine.isSegment);
            if (tProjPos == null)
                continue;
            //check if line is locked and return immediately
            if (tLine.locked) {
                var tResult = {};
                tResult.pos = tProjPos;
                tResult.line = tLine;
                return (tResult);
            }
            var tD = Math.abs(Vector3.DistanceSquared(pPos, tProjPos));
            if (tNearestLine == null || tD < tDistance) {
                tNewPos = tProjPos;
                tNearestLine = tLine;
                tDistance = tD;
            }
        }
        if (tNearestLine == null || tNewPos == null)
            return (null);
        var tSnappedDistance = null;
        if (pView != null) {
            //use pixel distance
            tSnappedDistance = pView.projectedDistance(pPos, tNewPos);
        }
        else {
            //use meter distance
            tSnappedDistance = Math.sqrt(tDistance);
        }
        if (tSnappedDistance != null && tSnappedDistance < pSnapDistance) {
            var tResult = {};
            tResult.pos = tNewPos;
            tResult.line = tNearestLine;
            return (tResult);
        }
        return (null);
    };
    SnapLine.prototype.updateDirection = function () {
        this.mDirection = this.mPoint2.subtract(this.mPoint1);
        this.mDirection.normalize();
    };
    return SnapLine;
}());
export { SnapLine };
